import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import call from "./modules/call";
import auth from "./modules/auth";
import contacts from "./modules/contacts";
import global from './modules/global';
import sessions from './modules/sessions';
import resetPassword from './modules/resetPassword';
import screenshots from "./modules/screenshots";
import notes from "./modules/notes";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    call,
    auth,
    contacts,
    global,
    sessions,
    resetPassword,
    screenshots,
    notes
  },
  plugins: [
    createPersistedState({
      paths: ['auth']
    })
  ]
});

export default store;
